"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http"); //, RequestOptions, RequestMethod
var logentries_client_config_1 = require("../../logentries.client.config");
var models_1 = require("../../models");
var LogentriesService = /** @class */ (function () {
    /**
     * Initialises a new instance of the LogentriesService class.
     * @param http
     * @param config
     */
    function LogentriesService(http, config) {
        this.http = http;
        this.config = config;
        this.logentriesEndpoint = "https://webhook.logentries.com/noformat/logs/";
    }
    LogentriesService.prototype.log = function (level, message, retry) {
        var _this = this;
        if (retry === void 0) { retry = 0; }
        var stack = '';
        // Truncate message to abide logentries character limit
        if (message instanceof Error) {
            // removes all 3 types of line breaks and webpack path
            message.stack = message.stack.replace(/(\r\n|\n|\r)/gm, " ").split('webpack-internal:///../../../').join('');
            stack = message.stack.length + message.message.length > 8192 ? message.stack.substring(0, 8192 - message.message.length) : message.stack;
        }
        else
            message = message.length > 8192 ? message.substring(0, 8192) : message;
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
        //, 'ngsw-bypass' : 'true'
        var queryParams = new http_1.HttpParams()
            .set('ngsw-bypass', 'true');
        //let options = new RequestOptions({
        //  method: RequestMethod.Post,
        //  headers: headers,
        //  body: `${level.name} ${window.location.pathname} | ${message} | user-agent: ${window.navigator.userAgent} | trace: ${stack}`
        //});
        //this.http.request(this.logentriesEndpoint + this.config.LogentriesToken, options).toPromise()
        //  .catch((error) => {
        //    // Recursive call once error log().
        //    if (retry == 0) this.log(level, `[Error] Failed to send log to the logentries server: ${error.message}`, ++retry);
        //  });
        var body = level.name + " " + window.location.pathname + " | " + message + " | user-agent: " + window.navigator.userAgent + " | trace: " + stack;
        var req = new http_1.HttpRequest('POST', this.logentriesEndpoint + this.config.LogentriesToken, body, { headers: headers, params: queryParams });
        this.http.request(req)
            .toPromise()
            .catch(function (error) {
            // Recursive call once error log().
            if (retry == 0)
                _this.log(level, "[Error] Failed to send log to the logentries server: " + error.message, ++retry);
        });
    };
    LogentriesService.prototype.debug = function (message) {
        this.log(models_1.Level.DEBUG, message);
    };
    LogentriesService.prototype.info = function (message) {
        this.log(models_1.Level.INFO, message);
    };
    LogentriesService.prototype.notice = function (message) {
        this.log(models_1.Level.NOTICE, message);
    };
    LogentriesService.prototype.warn = function (message) {
        this.log(models_1.Level.WARNING, message);
    };
    LogentriesService.prototype.error = function (message) {
        this.log(models_1.Level.ERROR, message);
    };
    LogentriesService.prototype.crit = function (message) {
        this.log(models_1.Level.WARNING, message);
    };
    LogentriesService.prototype.alert = function (message) {
        this.log(models_1.Level.ALERT, message);
    };
    LogentriesService.prototype.emerg = function (message) {
        this.log(models_1.Level.EMERGENCY, message);
    };
    LogentriesService = __decorate([ __param(1, core_1.Inject(logentries_client_config_1.LOGENTRIES_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], LogentriesService);
LogentriesService.ɵfac = function LogentriesService_Factory(t) { return new (t || LogentriesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(logentries_client_config_1.LOGENTRIES_CLIENT_CONFIG)); };
LogentriesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LogentriesService, factory: function (t) { return LogentriesService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LogentriesService, [{
        type: core_1.Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [logentries_client_config_1.LOGENTRIES_CLIENT_CONFIG]
            }] }]; }, null); })();
    return LogentriesService;
}());
exports.LogentriesService = LogentriesService;

